<template>
  <div class="flex items-center lg:h-full">
    <GfrMenuNav class="!hidden lg:!flex">
      <GfrMenuList>
        <GfrMenuItem v-for="(item, index) in menuList" :key="index" :as-trigger="hasChildren(item)">
          <GfrMenuLink
            class="uppercase"
            :to="formatRoutePath(item.link)"
            :target="isNewTabOpen(item) ? '_blank' : '_self'"
            has-active-line
          >
            {{ item.name }}
            <IconsOutArrow
              v-if="isOutsideLink(item)"
              class="ml-2 mt-0.5 h-3.5 w-3.5 rtl:mr-2 rtl:ml-0 rtl:-rotate-90"
            />
            <IconsArrow
              v-else-if="hasChildren(item)"
              class="ml-2 mt-0.5 h-3.5 w-3.5 rtl:ml-0 rtl:mr-2 transition-transform duration-300 group-data-[state=open]:rotate-180"
            />
          </GfrMenuLink>
          <GfrMenuView v-if="hasChildren(item)">
            <GfrMenuContent :level="item.level || 3">
              <GfrMenuList class="gfr-menu-content-list">
                <GfrMenuItem v-for="(subitem, i) in item.children" :key="i" class="gfr-menu-content-item">
                  <GfrMenuLink
                    class="gfr-menu-content-link text-[#D1D1D1]"
                    :class="
                      item.level === 2
                        ? 'hover:text-primary hover:font-bold hover:bg-[#363A41]'
                        : '!text-xs !font-regular'
                    "
                    :to="formatRoutePath(subitem.link)"
                    :target="isNewTabOpen(subitem) ? '_blank' : '_self'"
                  >
                    <NuxtImg
                      v-if="subitem.icon"
                      :src="subitem.icon"
                      alt="icon"
                      class="w-4 h-4 mr-1"
                      format="webp"
                      quality="80"
                    />
                    {{ subitem.name }}
                    <IconsOutArrow v-if="isOutsideLink(subitem)" class="ml-1 mt-0.5 h-3.5 w-3.5" />
                  </GfrMenuLink>
                  <GfrMenuList v-if="hasChildren(subitem)" class="gfr-menu-content-list">
                    <GfrMenuItem v-for="(grandItem, j) in subitem.children" :key="j" class="gfr-menu-content-item">
                      <GfrMenuLink
                        class="gfr-menu-content-link !text-sm !font-bold text-white hover:text-primary"
                        :to="formatRoutePath(grandItem.link)"
                        :target="isNewTabOpen(grandItem) ? '_blank' : '_self'"
                      >
                        <NuxtImg
                          v-if="grandItem.icon"
                          :src="grandItem.icon"
                          alt="icon"
                          class="w-4 h-4 mr-1"
                          format="webp"
                          quality="80"
                        />
                        {{ grandItem.name }}
                        <IconsOutArrow v-if="isOutsideLink(grandItem)" class="ml-1 mt-0.5 h-3.5 w-3.5" />
                      </GfrMenuLink>
                    </GfrMenuItem>
                  </GfrMenuList>
                </GfrMenuItem>
              </GfrMenuList>
            </GfrMenuContent>
          </GfrMenuView>
        </GfrMenuItem>
      </GfrMenuList>
    </GfrMenuNav>
    <GfrSlideMenuNav class="flex lg:hidden" :dir="$route.params.lang === 'ar' ? 'rtl' : 'ltr'">
      <GfrSlideMenuList>
        <GfrSlideMenuItem v-for="(item, index) in menuList" :key="index" :as-trigger="hasChildren(item)">
          <GfrSlideMenuLink
            class="uppercase"
            :to="formatRoutePath(item.link)"
            :target="isNewTabOpen(item) ? '_blank' : '_self'"
          >
            {{ item.name }}
            <IconsOutArrow v-if="isOutsideLink(item)" class="h-3 w-3 rtl:-rotate-90" />
            <IconsArrow
              v-else-if="hasChildren(item)"
              class="h-3 w-3 transition-transform duration-300 group-data-[state=open]:rotate-180"
            />
          </GfrSlideMenuLink>
          <GfrSlideMenuContent v-if="hasChildren(item)" class="hidden group-data-[state=open]:block">
            <GfrSlideMenuList as-child>
              <GfrSlideMenuItem v-for="child in item.children" :key="child.id" :as-trigger="hasChildren(item)" as-child>
                <GfrSlideMenuLink
                  :to="formatRoutePath(child.link)"
                  :target="isNewTabOpen(child) ? '_blank' : '_self'"
                  as-child
                >
                  <div class="flex items-center">
                    <NuxtImg
                      v-if="child.icon"
                      :src="child.icon"
                      alt="icon"
                      class="w-4.5 h-4.5 mr-1"
                      format="webp"
                      quality="80"
                    />
                    {{ child.name }}
                  </div>
                  <IconsOutArrow v-if="isOutsideLink(child)" class="h-3 w-3 rtl:-rotate-90" />
                  <template v-else-if="hasChildren(child)">
                    <IconsArrow
                      class="h-3 w-3 transition-transform duration-300 group-data-[state=open]/child:rotate-180"
                    />
                    <!-- <IconsArrow
                      class="hidden h-4 w-4 transition-transform duration-300 group-data-[state=open]/child:block"
                    /> -->
                  </template>
                </GfrSlideMenuLink>
                <GfrSlideMenuContent v-if="hasChildren(child)" class="hidden group-data-[state=open]/child:block">
                  <GfrSlideMenuList>
                    <GfrSlideMenuItem v-for="grandChild in child.children" :key="grandChild.id">
                      <GfrSlideMenuLink
                        :to="formatRoutePath(grandChild.link)"
                        :target="isNewTabOpen(grandChild) ? '_blank' : '_self'"
                        as-child
                        class="!font-bold"
                      >
                        <div class="flex items-center">
                          <NuxtImg
                            v-if="grandChild.icon"
                            :src="grandChild.icon"
                            alt="icon"
                            class="w-4.5 h-4.5 mr-1"
                            format="webp"
                            quality="80"
                          />
                          {{ grandChild.name }}
                        </div>
                        {{ grandChild.name }}
                        <IconsOutArrow v-if="isOutsideLink(grandChild)" class="h-3 w-3 rtl:-rotate-90" />
                      </GfrSlideMenuLink>
                    </GfrSlideMenuItem>
                  </GfrSlideMenuList>
                </GfrSlideMenuContent>
              </GfrSlideMenuItem>
            </GfrSlideMenuList>
          </GfrSlideMenuContent>
        </GfrSlideMenuItem>
      </GfrSlideMenuList>
    </GfrSlideMenuNav>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import type { ConfigApiMenu, ExtraApiSocialMedia } from '@/server/types'
const store = useStore()
const { formatTransify } = store
const { config } = storeToRefs(store)
const socialMediaMenu = computed(() => {
  if (!config.value.social_media) {
    return []
  }
  const menu: ConfigApiMenu[] = config.value.social_media.map((item: ExtraApiSocialMedia, index: number) => {
    return {
      id: index + 1,
      icon: item.icon,
      name: item.name,
      link: item.url,
      deeplink: item.deeplink,
      is_new_tab: 1,
      is_outside_website: 0
    }
  })
  return menu
})
const menuList: ComputedRef<ConfigApiMenu[]> = computed(() => {
  const list = [...config.value.menu]
  if (socialMediaMenu.value.length > 0) {
    list.push({
      id: config.value.menu.length + 1,
      name: formatTransify('UGC_OFFICIAL_WEBSITE_JOINUS'),
      link: '',
      level: 2,
      is_new_tab: 0,
      is_outside_website: 0,
      children: socialMediaMenu.value
    })
  }
  return list
})
const route = useRoute()
function formatRoutePath(link: string) {
  return link.replace('{lang}', route.params.lang as string)
}
function hasChildren(item: ConfigApiMenu) {
  return !!item.children && item.children.length > 0
}
function isOutsideLink(item: ConfigApiMenu) {
  return item.is_outside_website === 1
}
function isNewTabOpen(item: ConfigApiMenu) {
  return item.is_new_tab === 1
}
</script>
